import { useEffect, useState } from 'react';

function remaining(target) {
  if (!(target instanceof Date) || Number.isNaN(target.getTime())) return null;
  const ms = target.getTime() - Date.now();
  if (ms <= 0) return null;
  return {
    days: Math.floor(ms / 86400000),
    hours: Math.floor(ms / 3600000) % 24,
    minutes: Math.floor(ms / 60000) % 60,
    seconds: Math.floor(ms / 1000) % 60,
  };
}

function useCountdown(target) {
  const [value, setValue] = useState(() => remaining(target));

  useEffect(() => {
    if (!(target instanceof Date) || Number.isNaN(target.getTime())) return undefined;
    setValue(remaining(target));
    const id = setInterval(() => setValue(remaining(target)), 1000);
    return () => clearInterval(id);
  }, [target]);

  return value;
}

export default useCountdown;
